import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./Reveal";

const GA_ID = process.env.REACT_APP_GA_ID;
const KEY = "or-consent";

export function loadAnalytics() {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function trackPageView(path) {
  if (window.__gaLoaded && window.gtag && localStorage.getItem(KEY) === "all") {
    window.gtag("event", "page_view", { page_path: path });
  }
}

export function resetConsent() {
  localStorage.removeItem(KEY);
  window.location.reload();
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(KEY);
    if (!choice) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
    if (choice === "all") loadAnalytics();
    return undefined;
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "all") loadAnalytics();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="fixed bottom-5 left-5 right-5 z-[80] sm:right-auto sm:max-w-md"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <div className="border border-line/70 bg-charcoal/95 p-6 shadow-2xl shadow-black/50 backdrop-blur-md">
            <p className="kicker">Privacy</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">
              This site works without tracking. If you allow it, privacy-conscious analytics
              (Google Analytics 4) help us understand which ideas resonate. No advertising, no
              data sales, ever.
            </p>
            <div className="mt-5 flex flex-col gap-2 sm:flex-row">
              <button
                onClick={() => choose("all")}
                className="btn-primary flex-1 !px-4 !py-2.5"
                data-testid="cookie-accept-analytics"
              >
                Allow analytics
              </button>
              <button
                onClick={() => choose("essential")}
                className="btn-ghost flex-1 !px-4 !py-2.5"
                data-testid="cookie-essential-only"
              >
                Essential only
              </button>
            </div>
            <p className="mt-4 text-[11px] leading-relaxed text-slate-500">
              Details in the{" "}
              <Link to="/privacy" className="text-glow/80 underline-offset-2 hover:underline" data-testid="cookie-privacy-link">
                privacy policy
              </Link>
              . You can change your mind anytime from the footer.
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
